import { render } from "./MultiviewContent.vue?vue&type=template&id=72f61998&scoped=true"
import script from "./MultiviewContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiviewContent.vue?vue&type=script&setup=true&lang=js"

import "./MultiviewContent.vue?vue&type=style&index=0&id=72f61998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f61998"],['__file',"src/views/MultiviewDash/MultiviewContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72f61998"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72f61998', __exports__)) {
    api.reload('72f61998', __exports__)
  }
  
  module.hot.accept("./MultiviewContent.vue?vue&type=template&id=72f61998&scoped=true", () => {
    api.rerender('72f61998', render)
  })

}


export default __exports__